var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 320,
    viewBox: "0 0 232 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116 320C180.065 320 232 267.17 232 202C232 155.36 205.4 115.04 166.79 95.8821C166.929 97.4029 167 98.9432 167 100.5C167 128.39 144.167 151 116 151C87.8335 151 65.0001 128.39 65.0001 100.5C65.0001 98.9432 65.0712 97.4029 65.2104 95.8821C26.6004 115.04 5.58772e-05 155.36 5.58772e-05 202C5.58772e-05 267.17 51.935 320 116 320Z",
    fill: "#4A86E8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116,
    cy: 50.5,
    rx: 51,
    ry: 50.5,
    fill: "#9DC3E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1d7b5df4829430a8907476d1baff1505.svg";
export { ForwardRef as ReactComponent };